import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useParams } from "react-router-dom"
import { IReplenishmentDto } from "../../../types/replenishment/IReplenishmentDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useStore } from "../../../stores/RootStoreContext"
import { MenuManager } from "../MenuManager"
import { MenuAdmin } from "../../admin/MenuAdmin"
import { ContractorCheckTab } from "./tabs/ContractorCheckTab"
import { DocsCheckTab } from "./tabs/DocsCheckTab"
import { CRRequestTab } from "./tabs/CRRequestTab"
import { CompanyTab } from "./tabs/CompanyTab"
import { PaymentCheckTab } from "./tabs/PaymentCheckTab"
import { IUser } from "../../../types/user/IUser"
import { IMG } from "../../common/CONST"

export const ReplenishmentManager: React.FunctionComponent = () => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const params = useParams()
  const [stage, setStage] = useState<string | undefined>()
  const [replenishment, setReplenishment] = useState<IReplenishmentDto>({ stage: "" })
  const [client, setClient] = useState<IUser>()
  const { userStore } = useStore()

  useEffect(() => {
    if (params.id) {
      TrinityAPI.getReplenishment(Number(params.id), response => {
        if (response.status === 200) {
          setReplenishment(response.data)
          if (response.data.stage === "DOCS") {
            setStage("CONTRACTOR")
          } else {
            setStage(response.data.stage)
          }
        }
      })
    }
  }, [])

  useEffect(() => {
    if (replenishment.userId) {
      TrinityAPI.getUser(replenishment.userId, response => {
        setClient(response.data)
      })
    }
  }, [replenishment.userId])

  const isPickable = (item: string) => {
    switch (item) {
      case "DOCS":
        return replenishment.status !== "NEW"
      case "COMPANY":
        return (
          replenishment.status !== "NEW" &&
          replenishment.status !== "DOC_NAC" &&
          replenishment.additionalAgreementBankId
        )
      case "CR":
        return replenishment.status !== "NEW" && replenishment.status !== "DOC_NAC" && replenishment.status !== "DOC"
      case "PAYMENT":
        return (
          replenishment.status === "CR_ACC" ||
          replenishment.status === "BILL_PAID" ||
          replenishment.status === "CR_FIX" ||
          replenishment.status === "DONE"
        )
      case "CR_FIX":
        return replenishment.status === "CR_FIX" || replenishment.status === "DONE"
    }
  }

  const getItemClazz = (item: string) => {
    if (item === stage) {
      return "deals-stage-item-active"
    } else {
      return !isPickable(item) ? "deals-stage-item-lock" : "deals-stage-item"
    }
  }

  const toCompanyStage = () => {
    if (!replenishment.additionalAgreementBankId) {
      setModalMessage({
        title: "Ошибка!",
        text: "Проверьте доп. соглашение и выберите соответствующий ему банк"
      })
      return
    } else {
      setStage("COMPANY")
    }
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      {userStore.isManager ? <MenuManager active={"replenishment"} /> : <MenuAdmin active={"replenishment"} />}
      <section className="deals-info" style={{ display: "block" }}>
        <Header clazzName={"header-main-deals"} />
        <div className="container">
          <h1 className="ui-heading">
            Рублевое пополнение {replenishment.id ? `№${replenishment.id}` : ""} на основании запроса №
            {replenishment.clientRequestId}
          </h1>
          <ul className="deal-stage-list">
            <li
              className={`deals-stage-item${stage === "CONTRACTOR" ? "-active" : ""}`}
              onClick={() => (replenishment.id ? setStage("CONTRACTOR") : void 0)}
            >
              Контрагент
            </li>
            <li
              className={getItemClazz("DOCS")}
              onClick={() => (isPickable("DOCS") ? setStage("DOCS") : void 0)}
              style={!isPickable("DOCS") ? { pointerEvents: "none" } : {}}
            >
              Документы
            </li>
            <li
              className={getItemClazz("COMPANY")}
              onClick={() => (isPickable("COMPANY") ? toCompanyStage() : void 0)}
              style={!isPickable("COMPANY") ? { pointerEvents: "none" } : {}}
            >
              Выбор компании
            </li>
            <li
              className={getItemClazz("CR")}
              onClick={() => (isPickable("CR") ? setStage("CR") : void 0)}
              style={!isPickable("CR") ? { pointerEvents: "none" } : {}}
            >
              Запрос курса
            </li>
            <li
              className={getItemClazz("PAYMENT")}
              onClick={() => (isPickable("PAYMENT") ? setStage("PAYMENT") : void 0)}
              style={!isPickable("PAYMENT") ? { pointerEvents: "none" } : {}}
            >
              Проверка оплаты
            </li>
            <li
              className={getItemClazz("CR_FIX")}
              onClick={() => (isPickable("CR_FIX") ? setStage("CR_FIX") : void 0)}
              style={!isPickable("CR_FIX") ? { pointerEvents: "none" } : {}}
            >
              Фиксация курса
            </li>
          </ul>

          <div className="profile-block">
            <img src={IMG.avatar} alt="" className="avatar-img" />
            <div className="profile-block-about">
              <h4 className="profile-name">{client?.name}</h4>
              <p className="main-header-item-text">{client?.username}</p>
              <p className="main-header-item-text">{client?.telegram ? `t.me/${client.telegram}` : ""}</p>
            </div>
          </div>
        </div>

        {stage === "CONTRACTOR" && (
          <ContractorCheckTab
            next={() => setStage("DOCS")}
            replenishment={replenishment}
            setReplenishment={setReplenishment}
          />
        )}
        {stage === "DOCS" && (
          <DocsCheckTab
            next={() => toCompanyStage()}
            replenishment={replenishment}
            setReplenishment={setReplenishment}
          />
        )}
        {stage === "COMPANY" && <CompanyTab replenishment={replenishment} setReplenishment={setReplenishment} />}
        {stage === "CR" && (
          <CRRequestTab stage={stage} replenishment={replenishment} setReplenishment={setReplenishment} />
        )}
        {stage === "PAYMENT" && <PaymentCheckTab replenishment={replenishment} setReplenishment={setReplenishment} />}
        {stage === "CR_FIX" && (
          <CRRequestTab stage={stage} replenishment={replenishment} setReplenishment={setReplenishment} />
        )}
      </section>
    </>
  )
}
